import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getBrandBanner, getBrandBannerImage, viewBrandBanner } from "../../../services/BrandBanner/BrandBanner";
import StoreUserStatusChange from "../StoreManagement/StoreUserStatusChange";
import BrandBannerStatusChange from "./BrandBannerStatusChange";
import BrandBannerAddModal from "./BrandBannerAddModal";
import { CONSUMER_BASE_URL } from "../../../services/BaseURL";

const BrandBannerView = () => {
  const navigate = useNavigate();
  const [brandBannerData, setBrandBannerData] = useState([]);
  const [brandBannerImage, setBrandBannerImage] = useState({});
  const [brandBannerAddModalVisible, setBrandBannerAddModalVisible] =
    useState(false);
  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [selectedBrandBanner,setSelectedBrandBanner] = useState({})

  const fetchBrandBanner = (data) => {
    setLoading(true);
    getBrandBanner(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setBrandBannerData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

    const fetchBrandBannerImage = (bannerCode) => {
      getBrandBannerImage(bannerCode)
        .then((response) => {
          if (!response.data.error) {
            const base64Img = "data:image/png;base64," + response.data;
            setBrandBannerImage((prev) => ({
              ...prev,
              [bannerCode]: base64Img,
            }));
          }
        })
        .catch((err) => console.error("Error:", err));
    };

  useEffect(() => {
    fetchBrandBanner(brandId);
  }, []);

   const openBase64ImageInNewWindow = (base64String) => {
     // Remove header if already included
     const base64 = base64String.replace(/^data:image\/(png|jpeg);base64,/, "");

     const byteCharacters = atob(base64);
     const byteNumbers = new Array(byteCharacters.length);

     for (let i = 0; i < byteCharacters.length; i++) {
       byteNumbers[i] = byteCharacters.charCodeAt(i);
     }

     const byteArray = new Uint8Array(byteNumbers);
     const blob = new Blob([byteArray], { type: "image/png" });
     const blobUrl = URL.createObjectURL(blob);

     window.open(blobUrl, "_blank");
   };

  // const ViewBrandBannerImage = () => {
  //   viewBrandBanner(brandId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const Res = response.data;
  //         setBrandBannerImageView(Res);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  const receiveDataFromBrandBannerStatusChange = ({ success }) => {
    if (success) {
      fetchBrandBanner(brandId);
    }
  };

  // Suppose binaryData is an ArrayBuffer or Uint8Array from your API
  // const blob = new Blob([brandBannerImageView], { type: "image/png" });
  // const url = URL.createObjectURL(blob);

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Location :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.location}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Banner Code :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.bannerCode}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() => {
                      setBrandBannerAddModalVisible(true);
                      setSelectedBrandBanner(item);
                    }}
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status ? "ACTIVE" : "INACTIVE"}
                    </p>
                  </div>
                  <BrandBannerStatusChange
                    status={item.status}
                    sendDataToBannerList={
                      receiveDataFromBrandBannerStatusChange
                    }
                    editData={item}
                    brandId={brandId}
                  />
                </div>
                <div
                  className="px-3 py-1 flex justify-content-between"
                  style={{
                    flex: 1,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Banner Name :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.bannerName}
                    </p>
                  </div>

                  {item.status && (
                    <div>
                      {brandBannerImage[item.bannerCode] ? (
                        <div
                          className="cursor-pointer"
                          onClick={() =>
                            openBase64ImageInNewWindow(
                              brandBannerImage[item.bannerCode]
                            )
                          }
                        >
                          <img
                            src={brandBannerImage[item.bannerCode]}
                            alt="banner"
                            style={{ width: 50 }}
                          />
                        </div>
                      ) : (
                        <div>
                          <p style={{ fontSize: 12, color: "#999" }}>
                            No Image Loaded
                          </p>
                          <div
                            className="cursor-pointer"
                            onClick={() =>
                              fetchBrandBannerImage(item.bannerCode)
                            }
                          >
                            <p>Click to View</p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Brand Images
              </p>
            </div>
            {/*<div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => setBrandBannerAddModalVisible(true)}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>*/}
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : brandBannerData?.length > 0 ? (
          <div>
            <div>{renderCardItem(brandBannerData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Brand Banner Found</p>
          </div>
        )}
      </div>

      <BrandBannerAddModal
        brandBannerAddModalVisible={brandBannerAddModalVisible}
        setBrandBannerAddModalVisible={setBrandBannerAddModalVisible}
        sendDataToBannerList={receiveDataFromBrandBannerStatusChange}
        brandId={brandId}
        selectedBrandBanner={selectedBrandBanner}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default BrandBannerView;
